import { george, i18n, observer, pr, React, RouteComponentProps, theme } from "aaa";
import { TopBackgroundColor } from "components/util/TopBackgroundColor";
import { ui } from "components/util/uiHelpers";
import auth from "stores/AuthStore";
import { pushRoute } from "stores/RouterFunctions";
import externalInterfaceStore from "../../stores/ExternalInterfaceStore";
import { CancelButton } from "../util/CancelButton";
import { GIGRoutes } from "./GIGRoutes";
import { GIGStore } from "./GIGStore";
import { themeColors } from "muiTheme";


// TODO same as LandingPage ListItem - make generic Component?
const ListItem = (props: { children: React.ReactNode }) => {
    return (
        <div style={{ display: "flex", alignItems: "flex-start", marginBottom: theme.MARGIN_SMALL }}>
            <pr.IconCheckmarkCircle style={{ color: ui.isDarkMode ? themeColors.d_grey_200 : themeColors.grey_300, flexShrink: 0 }} />
            <div style={{ marginLeft: theme.MARGIN_SMALL, lineHeight: "24px" }}>
                {props.children}
            </div>
        </div>
    );
};

const LandingPageHeader = () => {
    return (
        <pr.HeaderBackground
            style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center"
            }}
        >
            <img
                src={require("../../assets/illustration_gig.svg")}
                height={`${theme.HEADER_ICON_SIZE}px`}
                alt=""
            />
        </pr.HeaderBackground>
    );
};

type IProps = RouteComponentProps<{}> & {
    store: GIGStore
};

@observer
export class GIGPromotion extends React.Component<IProps, {}> {
    render() {
        if (this.props.store.isLoading()) {
            return (
                <george.LandingBackground>
                    <george.LoadingIndicator isLoading={this.props.store.isLoading()} height={ui.windowHeight} />
                </george.LandingBackground>
            );
        }

        return (
            <george.LandingBackground>
                <TopBackgroundColor />
                <george.PageWithActionButton>
                    {externalInterfaceStore.clientId === "georgeclient" &&
                        <a
                            href={externalInterfaceStore.federatedLoginUrl}
                            role="button"
                        >
                            <CancelButton showRight color="white" />
                        </a>
                    }
                    <LandingPageHeader />
                    <div style={{ padding: 15, paddingTop: 20, paddingBottom: 0 }}>
                        <pr.LandingPageTitle style={{ textAlign: "center" }}>
                            <i18n.FormattedMessage id="gig.promo.header" />
                        </pr.LandingPageTitle>
                        <br />
                        <pr.P_14_CONTENT>
                            <i18n.FormattedMessage id="gig.promo.textPart1" />
                        </pr.P_14_CONTENT>

                        <pr.H3_SEMI_16_TITLE style={{ marginTop: 32 }}>
                            {ui.__("gig.promo.subHeader")}
                        </pr.H3_SEMI_16_TITLE>
                        <br />
                        <ListItem>
                            <pr.P_14_CONTENT>
                                <i18n.FormattedMessage id="gig.promo.textPart2" />
                            </pr.P_14_CONTENT>
                        </ListItem>
                        <ListItem>
                            <pr.P_14_CONTENT>
                                <i18n.FormattedMessage id="gig.promo.textPart3" />
                            </pr.P_14_CONTENT>
                        </ListItem>
                        <ListItem>
                            <pr.P_14_CONTENT>
                                <i18n.FormattedMessage id="gig.promo.textPart4" />
                            </pr.P_14_CONTENT>
                        </ListItem>
                        <ListItem>
                            <pr.P_14_CONTENT>
                                <i18n.FormattedMessage id="gig.promo.textPart5" />
                            </pr.P_14_CONTENT>
                        </ListItem>
                    </div>
                    <george.ActionButton
                        messageId="gig.promo.button"
                        onClick={() => pushRoute(GIGRoutes.ACTIVATION)}
                        isLoading={this.props.store.isLoading()}
                    />
                </george.PageWithActionButton>
            </george.LandingBackground>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/gig/GIGPromotion.tsx